<app-image-panel  [formService]="itemView['dynamicFormService']"></app-image-panel>
<app-oib-service-panel></app-oib-service-panel>
<ntap-prime-common-itemview [ngClass]="{'hide-data': hideDataUntilChosenFromNormative}" #itemView></ntap-prime-common-itemview>